import { onWatcherCleanup, type Ref, watch } from "vue";

export const createResizeObserver = (
  target: Ref<HTMLElement | null | undefined>,
  callback: (entry: ResizeObserverEntry) => void
) => {
  watch(target, (element) => {
    if (!element) {
      return;
    }

    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];

      callback(entry);
    });

    onWatcherCleanup(() => observer.disconnect());
    observer.observe(element);
  });
};
